export default __webpack_public_path__ + "static/media/1437.05351a7c.png";